import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'help_center-retailer_brand_toggle_header-click';

/**
 * Toggle click events on retailer/brand home page in help center for new nav and search
 */
export function trackHelpCenterRetailerBrandToggleHeaderClick(
  retailerToken: string,
  brandToken: string,
  View: string,
  SwitchOption2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { retailerToken, brandToken, View, SwitchOption2 },
  });
}
